<template>
  <div>
    <div id="addr-search">
      <xm-input name="uid" v-model="val" ref="search" @blur="hideSuggestions(200)"></xm-input>
      <div class="suggestion-menu">
        <ul ref="dropdown" id="search-dropdown" v-if="showDropdown">
          <li class="suggestion" v-for="item in suggestions" :key="item.addr_id" @click="choice = item">{{item.formatted}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '../../lib/helpers'
import req from '../../lib/authRequest'
import XmInput from '../XmInput.vue'
import {mapGetters} from "vuex";
import logger from "../../lib/logger";

export default {
  name: "AddressAutoComplete",
  components: {
    XmInput,
  },
  data(){
    return {
      val: '',
      suggestions: [],
      choice: undefined,
      choice_address: undefined,
      clicked: false,
    }
  },
  props: ['value', 'initDisplayValue'],
  created(){
    this.debouncedSuggestions = helpers.debounce(this.getSuggestions, 750)
  },
  mounted(){
    this.val = this.value
    this.initializeFromHash();
    if (this.initDisplayValue !== undefined && this.initDisplayValue !== null && this.initDisplayValue !== ''){
      this.val = this.initDisplayValue;
    }
  },
  computed:{
    isValid(){
      return true
    },
    showDropdown(){
      return this.suggestions.length > 0
    },
    hasWarning() {
      return false
    },
    hasError() {
      return this.isValid === false
    },
    hasSuccess() {
      return this.isValid === true
    },
    ...mapGetters([
      'ssuInitGoogleAddressId'
    ])
  },
  watch:{
    hasWarning(newv){ this.formClasses(newv, 'has-warning') },
    hasSuccess(newv) { this.formClasses(newv, 'has-success') },
    hasError(newv) { this.formClasses(newv, 'has-error') },
    initDisplayValue (newv) { this.val = this.initDisplayValue; },
    val(newv) {
      if (newv){
        if (!this.clicked && this.initDisplayValue !== newv){
          this.debouncedSuggestions(newv);
        } else {
          this.clicked = false;
        }

      }
    },
    choice(newv){
      let val2 = newv
      let self = this
      setTimeout(()=>{
        self.clicked = true;
        self.val = val2.formatted;
        self.suggestions = []
        self.$emit('input', val2)
        self.getAddressDetails().then(() => {
          val2.address = self.choice_address.address;
          self.$emit('address-selected', val2)
        });
      }, 50)
      //

    },
    showDropdown(newv) {
      let style = this.$refs.search.$refs.input.style
      let px = newv?'0px':'4px'
      style.borderBottomLeftRadius = px
      style.borderBottomRightRadius = px
    },
    ssuInitGoogleAddressId: {
      handler: function(new_val, old_val) {
        if (new_val !== old_val) {
          this.initializeFromHash();
        }
        else {
          logger.debug('old google address: ', old_val.google_address_id);
          logger.debug('new google address: ', new_val.google_address_id);
        }
      },
      deep: true
    }
  },
  methods: {
    formClasses(newv, cls){
      this.$refs.uid.$refs.form.classList[newv ? 'add' : 'remove'](cls)
    },
    hideSuggestions(ms){
      let self = this
      setTimeout(()=>{
        self.suggestions = []
      }, ms)
    },
    getSuggestions(search) {
      let self = this
      return req.post({
        url:'/self_signup/address/suggestions',
        data: {search},
        success(data) {
          self.suggestions = data
        },
        error(result) {
          self.suggestions = []
          console.log('error getting address suggestions ', result)
        },
      })
    },
    getAddressDetails(){
      let self = this;
      return new Promise((resolve, reject) => {
        req.post({
          url:'/self_signup/address/details',
          data: {addr_id: self.choice.addr_id},
          success(data) {
            self.choice_address = data;
            return resolve(data);
          },
          error(result) {
            self.suggestions = []
            console.log('error getting address suggestions ', result)
            return reject(result);
          },
        })
      })
    },
    initializeFromHash() {
      if (this.ssuInitGoogleAddressId) {
        let self = this;
        this.choice = {'addr_id': this.ssuInitGoogleAddressId};
        this.getAddressDetails().then(() => {
          self.choice.address = self.choice_address.address;
          self.choice.formatted = self.choice_address.formatted;
          self.$emit('address-selected', self.choice)
        });
      }
      else {
        logger.debug('no google address id found', this.ssuInitGoogleAddressId)
      }
    },
  }
}
</script>

<style scoped>

#search-dropdown{
  position: absolute;
  background: white;
  background: rgba(255,255,255,0.7);
  backdrop-filter: blur(5px);
  z-index: 1000;
  border:1px solid #ccc;
  padding: 4px 0;
  margin-top: -15px;
  width:100%;
  padding-left: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: black;
}

.suggestion-menu{
  position: relative;
}

.suggestion{
  list-style-type: none;
  width: 100%;
  padding:4px 10px;
}

.suggestion:hover{
  cursor:pointer;
  background: #337AB7;
  color:white;
}

#uid-taken-warning{
  list-style-type: none;
  background: #959556;
  text-align: center;
}

#addr-search >>> input {
  font-size:26px;
  padding: 0 12px;
  color:#495057;
  line-height:1px;
}

</style>



// WEBPACK FOOTER //
// AddressAutoComplete.vue?666e8f60